<script>
    import OfferCategoryButton from './OfferCategoryButton.svelte';
    import { onMount } from 'svelte';

    export let onSelectionChange = () => {};

    let selectedPlatform = 'izzi';
    let selectedService = 'tv';
    let showAdditionalServices = true;

    let description = {
        heading: '',
        text: '',
        extraText: '',
    };

    function handleServiceSelection(service) {
        selectedService = service;
        description = getServiceDescriptionFromSelection();
        onSelectionChange({ detail: [selectedService] });
    }

    function getServiceDescriptionFromSelection() {
        if (selectedPlatform === 'izzi') {
            if (selectedService === 'tv') {
                return {
                    heading: '',
                    text: 'Relájate con increíbles canales de TV',
                    extraText: '¡La decisión es tuya!',
                };
            }

            if (selectedService === 'movil') {
                return {
                    heading: '',
                    text: 'Mantente conectado con tu móvil.',
                    extraText: '¡La decisión es tuya!',
                };
            }
        }

        if (selectedPlatform === 'sky') {
            return {
                heading: '',
                text: 'Disfruta de los mejores canales de TV con Sky',
                extraText: '¡La decisión es tuya!',
            };
        }

        return {
            heading: '',
            text: '',
            extraText: '',
        };
    }

    onMount(() => {
        description = getServiceDescriptionFromSelection();
    });
</script>

{#if showAdditionalServices}
    <div class="offer-content-title">
        Selecciona el servicio que te interesa
    </div>
    <div class="service-selection">
        <OfferCategoryButton
            label="tv"
            icon="/assets/img/icons/symbol-defs.svg#icon-tv"
            isActive={selectedService === 'tv'}
            onClick={() => handleServiceSelection('tv')}
            withVariableWidth={true}
        />
        <OfferCategoryButton
            label="movil"
            icon="/assets/img/icons/symbol-defs.svg#icon-smartphone"
            isActive={selectedService === 'movil'}
            onClick={() => handleServiceSelection('movil')}
            withVariableWidth={true}
        />
    </div>
{/if}
<p>
    <span class="fw-bold">{description.heading}</span>
    {description.text}
    <span class="fw-bold">{description.extraText}</span>
</p>
